module.exports = __webpack_public_path__ + "img/202MD.750.e50b53e3.png";